// extracted by mini-css-extract-plugin
module.exports = {"modal-header":"_3ccufKMM","modal-title":"_2EjJNfYE","modal-message":"_3dAXLRZh"};